import { createActions, createReducer, Types as ReduxSauceTypes } from 'reduxsauce';
import INITIAL_STATE from './carousel-items-model.js';

const defaultHandler = (state = INITIAL_STATE) => state;

const fetched = (state, { data }) => ({
  ...state,
  items: data,
});

const openModal = (state, { carouselItem }) => ({
  ...state,
  isModalOpen: true,
  carouselToUpdate: carouselItem,
});

const closeModal = (state) => ({
  ...state,
  isModalOpen: false,
  carouselToUpdate: INITIAL_STATE.carouselToUpdate,
});

const updateOrder = (state, { oldIndex, newIndex }) => {
  const activeItems = state.items.filter((item) => item.active);
  const movedItem = activeItems.splice(oldIndex, 1)[0];
  activeItems.splice(newIndex, 0, movedItem);
  const updatedActiveItems = activeItems.map((item, index) => ({
    ...item,
    order: index + 1,
  }));
  const inactives = state.items.filter((item) => !item.active);
  return {
    ...state,
    items: [...updatedActiveItems, ...inactives],
    carouselItemsToUpdateOrder: updatedActiveItems.map((item) => ({
      id: item.id,
      order: item.order,
    })),
  };
};

export const { Types, Creators } = createActions({
  // Action Types
  carouselItemsFetched: ['data'],
  carouselItemsUpdateOrder: ['oldIndex', 'newIndex'],
  carouselItemsOpenModal: ['carouselItem'],
  carouselItemsCloseModal: [],

  // Async Actions
  carouselItemsCreateAsync: ['data'],
  carouselItemsUpdateAsync: ['data'],
  carouselItemsFetchAsync: [],
  carouselItemsDeleteAsync: ['id'],
  carouselItemsUpdateOrdersAsync: [],
});

export default createReducer(INITIAL_STATE, {
  [ReduxSauceTypes.DEFAULT]: defaultHandler,
  [Types.CAROUSEL_ITEMS_FETCHED]: fetched,
  [Types.CAROUSEL_ITEMS_OPEN_MODAL]: openModal,
  [Types.CAROUSEL_ITEMS_CLOSE_MODAL]: closeModal,
  [Types.CAROUSEL_ITEMS_UPDATE_ORDER]: updateOrder,
});
